module.exports = __webpack_public_path__ + "img/icon-close.ecf1a46c.svg";